import React, { useEffect, useState } from 'react'
// import { useRequestData } from '../../../Utilities/hooks'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { Spinner } from '../../Loaders/Loaders'
import Portal from 'components/Portal/Portal'
import { Modal, ConfirmDialog } from 'components/Modal/Modal'
import * as api from '../../../requests'
import { GraniteDataGrid } from '@tecuity/granite-ui'
import MergerModal from './MergerModal'
import Pencil from '@tecuity/sos-icons/react/pencil-solid'
import PlusHeavy from '@tecuity/sos-icons/react/plus-heavy'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'
import ExclamationPoint from '@tecuity/sos-icons/react/exclamation-point'
import { noop } from 'utilities'
import { useDispatch } from 'react-redux'
import { setErrorToast, setSuccessToast } from '../../../actions'

const BusinessMergersXref = () => {
  const dispatch = useDispatch()
  // const receiptItemTypes = useRequestData(api.GET_SETTINGS_RECEIPT_ITEM_TYPES, [], [])
  // const appReports = useRequestData(api.GET_APP_REPORTS, [], [])
  const [filingType, setFilingType] = useState('')
  const [filingTypeOptions, setFilingTypeOptions] = useState([])
  const [recordTypeOptions, setRecordTypeOptions] = useState([])
  const [recordSubTypeOptions, setRecordSubTypeOptions] = useState([])
  // const [businessStatusTypeOptions, setBusinessStatusTypeOptions] = useState([])
  const [rows, setRows] = useState([])
  const [selectedRow, setSelectedRow] = useState(defaultMergerXref)
  const [mergerModalOpen, setMergerModalOpen] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [isAdding, setIsAdding] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    api.GET_ALL_ENUM_LOOKUP_TYPE(
      'BusinessFilingType',
      (res) => {
        // console.log(res)
        setFilingTypeOptions([
          ...res
            .filter((t) => t.IsActive && t.IsMerger)
            .map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
        ])
        setLoading(false)
      },
      (err) => {
        setFilingTypeOptions([])
        console.error(err.message)
        setLoading(false)
      }
    )
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'RecordType',
      (res) => {
        // console.log(res)
        setRecordTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
      },
      (err) => {
        setRecordTypeOptions([])
        console.error(err.message)
      }
    )
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'RecordSubType',
      (res) => {
        // console.log(res)
        setRecordSubTypeOptions([
          { value: null, label: 'None' },
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
      },
      (err) => {
        setRecordSubTypeOptions([])
        console.error(err.message)
      }
    )
    // api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
    //   'Business',
    //   'StatusType',
    //   (res) => {
    //     // console.log(res)
    //     setBusinessStatusTypeOptions([
    //       ...res.map((t) => ({
    //         value: t.Id,
    //         label: t.Name,
    //       })),
    //     ])
    //   },
    //   (err) => {
    //     setBusinessStatusTypeOptions([])
    //     console.error(err.message)
    //   }
    // )
  }, [])

  const getList = () => {
    //api call
    if (filingType) {
      setLoading(true)
      api.GET_SETTINGS_ALL_BUSINESS_MERGER_TYPES_XREF(
        filingType,
        (data) => {
          setLoading(false)
          setRows(data)
        },
        (err) => {
          setLoading(false)
          console.error(err)
        }
      )
    } else {
      setRows([])
    }
  }

  useEffect(() => {
    getList()
  }, [filingType, recordTypeOptions, recordSubTypeOptions])

  const getRecordTypeName = (id) => {
    const type = recordTypeOptions.find((type) => type.value === id)
    return type ? type.label : ''
  }
  const getRecordSubTypeName = (id) => {
    const type = recordSubTypeOptions.find((type) => type.value === id)
    return type ? type.label : ''
  }

  const getFilingTypeName = (id) => {
    const type = filingTypeOptions.find((type) => type.value === id)
    return type ? type.label : ''
  }

  const columns = [
    {
      field: 'SurvivorBusinessRecordTypeId',
      flex: 1,
      headerName: 'Survivor Record Type',
      renderCell: (params) => {
        return getRecordTypeName(params.row.SurvivorBusinessRecordTypeId)
      },
    },
    {
      field: 'SurvivorRecordSubTypeName',
      flex: 1,
      headerName: 'Survivor Record Sub Type',
      renderCell: (params) => {
        return getRecordSubTypeName(params.row.SurvivorBusinessRecordSubTypeId)
      },
    },
    {
      field: 'NonSurvivorBusinessRecordTypeId',
      flex: 1,
      headerName: 'Non Survivor Record Type',
      renderCell: (params) => {
        return getRecordTypeName(params.row.NonSurvivorBusinessRecordTypeId)
      },
    },
    {
      field: 'NonSurvivorBusinessRecordSubTypeId',
      flex: 1,
      headerName: 'Non Survivor Record Sub Type',
      renderCell: (params) => {
        return getRecordSubTypeName(params.row.NonSurvivorBusinessRecordSubTypeId)
      },
    },
    {
      field: 'NonSurvivorBusinessFilingTypeId',
      flex: 1,
      headerName: 'Non Survivor Filing Type',
      renderCell: (params) => {
        return getFilingTypeName(params.row.NonSurvivorBusinessFilingTypeId)
      },
    },
    {
      field: 'Actions',
      headerName: 'Actions',
      flex: 0.5,
      resizeable: false,
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const row = params.row
        return (
          <div className="action-icons-wrapper" style={{ display: `inline` }}>
            <IconButton
              onClick={() => {
                setSelectedRow(row)
                setMergerModalOpen(true)
                setIsAdding(false)
              }}
              icon={<Pencil />}
              label="Edit"
            />
            <IconButton
              onClick={() => {
                setSelectedRow(row)
                setDeleteModalOpen(true)
              }}
              icon={<CrossHeavy />}
              label="Delete"
            />
            {(row.MissingSurvivorXref || row.MissingNonSurvivorXref) && (
              <IconButton
                onClick={() => {
                  setSelectedRow(row)
                  setMergerModalOpen(true)
                  setIsAdding(false)
                }}
                icon={<ExclamationPoint />}
                label="Missing Business Record to Filing Xref(s)"
              />
            )}
          </div>
        )
      },
    },
  ]

  const closeModal = (refreshList) => {
    // console.log(refreshList)
    if (refreshList) getList()
    setMergerModalOpen(false)
  }

  const finishDelete = () => {
    api.DELETE_MERGER_TYPE_XREF(
      selectedRow.MergerConfigurationXrefId,
      () => {
        getList()
        dispatch(setSuccessToast('Successfully Deleted XRef'))
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Delete XRef'))
      }
    )
  }

  return (
    <div className="settings-list-view">
      <h2>Business Mergers Xref</h2>
      <div className="custom-correspondence-options">
        <SelectBox
          label="Filing Type"
          value={filingType}
          onChange={(val) => {
            setFilingType(val)
          }}
          options={filingTypeOptions}
        />

        <ContextButton
          variant="primary"
          customCss={`height: min-content; margin-top: 5px`}
          onClick={() => {
            setSelectedRow(defaultMergerXref)
            setMergerModalOpen(true)
            setIsAdding(true)
          }}
          disabled={!filingType}
          rightIcon={
            <div className="checkmark-wrapper">
              <PlusHeavy />
            </div>
          }
        >
          Add Merger
        </ContextButton>
        {loading && (
          <div className="type-loader">
            <Spinner size="small" themeColor="dark-neutral" />
          </div>
        )}
      </div>

      <div className="settings-content">
        <div className="settings-full-width-column">
          <GraniteDataGrid
            columns={columns}
            rows={rows}
            getRowId={(row) => row.MergerConfigurationXrefId}
            pageSize={10}
            rowsPerPageOptions={[10]}
            onRowDoubleClick={(r) => {
              setSelectedRow(r.row)
              setMergerModalOpen(true)
              setIsAdding(false)
            }}
            rowHeight={32}
          />
        </div>
        <Portal isOpened={mergerModalOpen}>
          <Modal
            title={`${isAdding ? 'Add' : 'Edit'} Merger`}
            modalSize="large"
            autoHeight
            closeModal={() => setMergerModalOpen(false)}
          >
            <MergerModal
              selectedRow={selectedRow || defaultMergerXref}
              closeModal={closeModal}
              recordTypeOptions={recordTypeOptions}
              recordSubTypeOptions={recordSubTypeOptions}
              filingTypeOptions={filingTypeOptions}
              // businessStatusTypeOptions={businessStatusTypeOptions}
              getRecordTypeName={getRecordTypeName}
              getRecordSubTypeName={getRecordSubTypeName}
              getFilingTypeName={getFilingTypeName}
              // receiptItemTypes={receiptItemTypes}
              // appReports={appReports}
              filingType={filingType}
            />
          </Modal>
        </Portal>
        <Portal isOpened={deleteModalOpen}>
          <ConfirmDialog
            closeModal={() => {
              setDeleteModalOpen(false)
            }}
            onModalClosed={noop}
            message={`Are you sure you want to delete configuration?`}
            buttons={[
              { label: 'No', onClick: noop, className: 'btn-default' },
              {
                label: 'Yes',
                onClick: () => {
                  finishDelete()
                },
                className: 'btn-danger',
              },
            ]}
            modalStyle={{ borderRadius: 3 }}
          />
        </Portal>
      </div>
    </div>
  )
}

export default BusinessMergersXref

const defaultMergerXref = {
  MergerConfigurationXrefId: 0,
  BusinessFilingTypeId: 0,
  SurvivorBusinessRecordTypeId: 0,
  SurvivorBusinessRecordSubTypeId: 0,
  NonSurvivorBusinessRecordTypeId: 0,
  NonSurvivorBusinessRecordSubTypeId: 0,
  NonSurvivorBusinessFilingTypeId: 0,
  // PostMergerSurvivorBusinessStatusTypeId: 0,
  // ReportIds: [],
  // ReceiptItemTypeIds: [],
}
